import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 10h2a2 2 0 0 1 2 2v5h-3a2 2 0 1 1 0 -4h3","key":"svg-0"}],["path",{"d":"M14 7v10","key":"svg-1"}],["path",{"d":"M14 12a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-1a2 2 0 0 1 -2 -2l0 -3","key":"svg-2"}]]

const IconAlphabetLatin = createReactComponent('outline', 'alphabet-latin', 'AlphabetLatin', __iconNode);

export default IconAlphabetLatin;